import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://6bd4ae594d89613a6d267179a3d4c263@o1317061.ingest.us.sentry.io/4507576468111360',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.1,
  tracePropagationTargets: [],
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
});
